<template>
  <div>
    <div class="container">
      <div v-for="data in postdata" :key="data.id" class="blog">
        <div class="datapart">
          <router-link :to="data.id" class="blogtitle"
            >{{ data.title }}
            <p v-html="data.limiteddiscription"></p
          ></router-link>
          <h5>{{ data.date.toDate().toString().substring(0, 25) }}</h5>
        </div>
        <div class="imgpart">
          <img
            v-if="data.img"
            :src="data.img"
            :alt="data.title"
            class="blogimg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseApp from "../firebaseInit";
import Vue from "vue";
var db = firebaseApp.firestore();
export default {
  data() {
    return {
      postdata: [],
      limiteddisc: "",
      checkforck: false,
    };
  },
  created() {
    this.showabledata();
    document.title = "Ckstocks Blogs";
  },
  methods: {
    truncate(str, no_words) {
      return str.split(" ").splice(0, no_words).join(" ");
    },
    showabledata() {
      Vue.$toast.open({
        message: "Loading",
        type: "info",
        position: "bottom-left",
      });

      db.collection("posts")
        .orderBy("date", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.limiteddisc =
              this.truncate(doc.data().disc, 20) +
              "..." +
              "<span style='color:rgb(0,0,0,.7);text-weight:normal'>More<span>";
            this.postdata.push({
              id: doc.id,
              title: doc.data().title,
              disc: doc.data().disc,
              //   auther: doc.data().auther,
              date: doc.data().date,
              img: doc.data().img,
              limiteddiscription: this.limiteddisc,
            });
          });
        });
    },
  },
};
</script>


<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.username span {
  text-transform: capitalize;
  font-weight: 600;
}
.username {
  margin-left: 80%;
}

@keyframes addbtn {
  50% {
    transform: rotateZ(90deg);
  }
  100% {
    transform: rotateZ(100deg);
  }
}

.container {
  padding-top: 10px;
  border-radius: 5px;
  width: 80%;
  min-width: 80%;
  margin-left: 50%;
  height: fit-content;
  transform: translate(-50%, 0%);
  margin-bottom: 40px;
}
.blog {
  background-color: rgb(230, 230, 230);
  padding: 20px;
  border-radius: 5px;
  margin: 13px 0px 13px 0px;
  text-decoration: none;
  transition: 0.4s;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: fit-content;
}

.blog:hover {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.356);
}
.blogtitle {
  position: relative;
  font-size: 23px;
  font-weight: 600;
  align-self: start;
}
.blogtitle p {
  font-size: initial;
  font-weight: initial;
  text-decoration: none;
}
.blogtitle p span {
  text-decoration: underline;
  color: rgba(0, 0, 0, 0.651);
}
.blogimg {
  height: 150px;
  width: 250px;
  float: right;
  transition: 0.4s;
}

a:-webkit-any-link {
  text-decoration: none;
  color: black;
}

@media screen and (max-width: 650px) {
  .blog {
    display: grid;
    justify-content: center;
  }
  .blogimg {
    width: 90%;
    height: auto;
    float: left;
  }
  .container {
    justify-items: center;
    width: 95%;
  }
}
</style>